import React, {useState, useEffect, useContext, ChangeEvent} from "react";

import {
  UnorderedList,
  ListItem,
  Container, Button, VStack,
  HStack,
  CheckboxGroup,
  Checkbox, useCheckboxGroup, Divider,
  Textarea,
  Select,
  Text,
  Box,
  Spacer,
  Table,
  Tr,
  Td,
  Img,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter,

  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,

} from '@chakra-ui/react';
import {useNavigate, useParams, Link} from "react-router-dom";
import {client, baseUrl} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"
import {WorkComponent} from "@/components/ItemComponent"
import { Work } from "@/pbgen/v1/main_pb";
import { Courseware, User } from "@/pbgen/v1/main_pb";
import { Directory } from "@/pbgen/v1/main_pb";


import './Works.css';
import './Coursewares.css';

const mainColor = '#df6694'

function drawAddTable(root: Directory, navigate: any, existingWorks: number[]) {
  return (

    <Table className="coursewares_table"><tbody>
    {root.files.map((f) =>
      <Tr className="coursewares_table_item">
        <Td key={'td-${f.path.join("/")}'} p={2} m={0}>
          <Checkbox key={'checkbox-${f.path.join("/")}'} isDisabled={existingWorks.includes(f.optCourseware?.id || 0)} value={f.optCourseware?.id}>
          <HStack>
            <Img className="coursewares_table_thumbnail" src={`${baseUrl}/scratch_api/assets/${f.optCourseware?.thumbnailId}`} />
            <span dangerouslySetInnerHTML={{ __html: f.optCourseware?.title ?? '' }}></span>
          </HStack>
          </Checkbox>
        </Td>
      </Tr>
    )}
    {
      root.directories.map((d) =>
        <>
        <tr>
        <td colSpan={2} className="coursewares_table_label"><span>{d.base}</span></td></tr>
        <tr><td>{drawAddTable(d, navigate, existingWorks)}</td></tr>
        </>
      )
    }
    </tbody></Table>
  
  );
}

function drawTree(root: Directory, navigate: any, existingWorks: number[]) {
  console.log("Drawn")
  return (<UnorderedList>
    {
      root.files.map((f) =>
        <ListItem key={f.path.join("/")}><Checkbox isDisabled={existingWorks.includes(f.optCourseware?.id || 0)} value={f.optCourseware?.id}>{f.base}</Checkbox></ListItem>
      )
    }
    {
      root.directories.map((d) =>
        <>
          <ListItem >{d.base}</ListItem>
          {drawTree(d, navigate, existingWorks)}
        </>
      )
    }
  </UnorderedList>);
}


export const GroupWorks = () => {
  const { vid } = useParams();
  const [vendors, setVendors] = useState<User[]>([]);
  const [root, setRoot] = useState<Directory>(new Directory());

  const [currentUser, setCurrentUser] = useState("")


  const [ventorId, setVentorId] = useState<string>("")
  const [status, setStatus] = useState("");
  const [saveError, setSaveError] = useState("");
 
  const [selectedWorks, setSelectedWorks] = useState<number[]>([])
  const [existingWorks, setExistingWorks] = useState<number[]>([])

  const { isOpen: isErrorOpen, onOpen: onErrorOpen, onClose: onErrorClose } = useDisclosure()
  const { isOpen: isFinishOpen, onOpen: onFinishOpen, onClose: onFinishClose } = useDisclosure()
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const cancelDeleteRef = React.useRef<HTMLButtonElement | null>(null)
  const { isOpen: isDeleteFinishOpen, onOpen: onDeleteFinishOpen, onClose: onDeleteFinishClose } = useDisclosure()

  const {globalState, setGlobalState} = useContext(GlobalContext);


  const navigate = useNavigate();


  useEffect(() => {
    (async () => {
      if (! vid) {
        //事業者情報を取得
        const resp = await client.getVendors({
          bearerToken: bearerToken(),
        });
        if (!resp.currentUser) {
          navigate("/login", {relative: "path"});
          return;
        }
        if (resp.vendors.length === 0) {
          navigate("/manage", {relative: "path"});
          return
        }
        const newVid = resp.vendors[0].id;
        navigate(`../vendors/${newVid}/groupworks`, {relative: "path", replace: true});
        return
      }

      //事業者リストを取得
      const resp2 = await client.getVendors({
        bearerToken: bearerToken(),
      });
      setVendors(resp2.vendors);

      //教材ツリーを取得
      const resp3 = await client.getCoursewareTree({
        bearerToken: bearerToken(),
        userId: vid,
      });
      setGlobalState({...globalState, currentUser: resp3.currentUser ?? emptyUser()})
      setCurrentUser(resp3.currentUser?.optName ?? "")
      setVentorId(resp3.currentUser?.optVendorId ?? "")
      setRoot(resp3.root ?? new Directory())

      //生徒一覧を取得
      const resp4 = await client.getStudents({
        bearerToken: bearerToken(),
        optVendorId: vid,
        optSchoolroomId: undefined,
      });

        //一人の生徒の教材状況を反映
        if (resp4.students.length > 0) {
        const student = resp4.students[0]
        //console.log(student)
        const resp5 = await client.getWorks({
          bearerToken: bearerToken(),
          userId: student.id,
        });
        setExistingWorks(resp5.works.map((work) => work.coursewareId))
        setSelectedWorks(resp5.works.map((work) => work.coursewareId))
        //console.log(selectedWorks)
        //console.log(existingWorks)
      }

    })();
  }, [vid]) // eslint-disable-line react-hooks/exhaustive-deps


  const save = async () => {

    //console.log(selectedWorks);
    
    const resp = await client.addGroupWorks({
      bearerToken: bearerToken(),
      venderId: vid,
      role: "student",
      coursewareIds: selectedWorks,
    });
    if (resp.error) {
      setSaveError(resp.error.message);
      onErrorOpen();
      return
    } else {
      onFinishOpen();
    }
    /*
    const resp = await client.addWorks({
      bearerToken: bearerToken(),
      studentId: sid,
      coursewareIds: selectedWorks,
    });
    setExistingWorks(selectedWorks);
    */
    onFinishOpen();
  }

  const handleOk = () => {
    navigate(-1);
  };

  const handleSaveClose = () => {
    onFinishClose();
    window.location.reload();
  };

  const handleDeleteClose = () => {
    onDeleteFinishClose();
    window.location.reload();
  };


  const drawTabs = (VendorId: string | undefined) => {
    return (
      <Box>
        <Tabs variant="enclosed-colored">
          {/* タブリスト */}
          <TabList>
          {
            root.directories.map((d) =>
              <>
              <Tab key={'tab-${d.id}'}
                sx={{
                  border: '1px #df6694 solid',
                  background: 'white',
                  _selected : { color: 'white', bg: '#df6694' },
                  _hover : { bg: '#fdcbde' },
                }}
              >
                {(d.base === VendorId) ? "教材" : d.base}
              </Tab>
              </>
            )
          }
          </TabList>
  
          {/* タブのコンテンツ */}
          <TabPanels>
          {
            root.directories.map((d) =>
              <>
              <TabPanel p={0} key={'tabpanel-${d.id}'}>
  
                <CheckboxGroup key={'checkboxgrp-${d.id}-${existingWorks.join(",")}'} value={selectedWorks} onChange={
                  (selectedValues) => {
                    setSelectedWorks(selectedValues.map(n => Number(n)));
                    console.log("c19c168", selectedValues);
                  }
                }>

                  {drawAddTable(d, navigate, existingWorks)}
  
                </CheckboxGroup>
  
              </TabPanel>
              </>
            )
          }
          </TabPanels>
        </Tabs>
      </Box>
    );
  };

  return <Page>


    <PageHeader title={"グループ教材管理"}>
      <HStack padding={2}>

        <Select placeholder="事業者を選択" value={vid} onChange={(e) => navigate(`../../${e.target.value}/groupworks`, {relative: "path", replace: true})}>
            {
              vendors.map((vendor) =>
                <option key={vendor.id} value={vendor.id}>{vendor.optName ?? ""}</option>
              )
            }
        </Select>
  
        <Text className="works_class_text" >事業者ID:{vid}</Text>
        <Button px={9} onClick={save}>教材保存</Button>
        <Button px={9} onClick={async () => {onDeleteOpen()}}>教材削除</Button>

        <Button px={12} as={Link} to="/manage">メニューに戻る</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button px={6} isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>




      </HStack>

      <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} leastDestructiveRef={cancelDeleteRef}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>
              生徒の削除
            </AlertDialogHeader>
            <AlertDialogBody>
              生徒の教材をすべて削除しますか？
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelDeleteRef} onClick={onDeleteClose}>
                キャンセル
              </Button>
              <Button  ml={3} onClick={async () => {
                const resp = await client.deleteGroupWork({
                  bearerToken: bearerToken(),
                  venderId: vid,
                  role: "student"
                });
                if (resp.error) {
                    console.log(resp.error)
                }
                onDeleteClose()
                onDeleteFinishOpen();
              }}>削除</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

    </PageHeader>

  


    <PageBody>
      <VStack>
        { drawTabs(vid) }
      </VStack>

      <VStack>
        <Modal isOpen={isFinishOpen} onClose={onFinishClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>保存</ModalHeader>
            <ModalCloseButton />
            <ModalBody>教材情報を保存しました。</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleSaveClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={isDeleteFinishOpen} onClose={onDeleteFinishClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>削除</ModalHeader>
            <ModalCloseButton />
            <ModalBody>教材情報を削除しました。</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleDeleteClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={isErrorOpen} onClose={onErrorClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{saveError}</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onErrorClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

      </VStack>
    </PageBody>
  </Page>
}
